import { useQuery } from "@tanstack/react-query";
import { getProfile } from "../../api/apiUsers";
import i18next from "i18next";

export function useGetProfile(id) {

    const {
        isLoading,
        data: Profile,
        error,
    } = useQuery({
        queryKey: ["Profiles", i18next.language],
        queryFn: () => getProfile(id),
        retry: false,
    });

    return { isLoading, error, Profile };
}
